import { FormattedMessage } from 'react-intl';
import React from 'react';
import { CheckboxButton, CheckboxDescription, CheckboxInput, CheckboxLabel, CheckboxTitle } from './Checkbox.styles';
import { ICheckbox } from '../SaveInstrumentCheckbox.types';

function Checkbox({ classNamePrefix, value, onClick }: ICheckbox) {
  return (
    <>
      <CheckboxTitle className={`${classNamePrefix}-title`}>
        <FormattedMessage id="pay.saveInstrument.title" />
      </CheckboxTitle>
      <CheckboxDescription className={`${classNamePrefix}-description`}>
        <FormattedMessage id="pay.saveInstrument.description" />
      </CheckboxDescription>
      <CheckboxLabel className={`${classNamePrefix}-wrapper`}>
        <CheckboxInput className={`${classNamePrefix}-checkbox`} type="checkbox" checked={value} onClick={onClick} />
        <CheckboxButton
          className={`${classNamePrefix}-button`}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}
        >
          <FormattedMessage id="pay.saveInstrument.button_text" />
        </CheckboxButton>
      </CheckboxLabel>
    </>
  );
}

export default Checkbox;
